<template>
	<div class="news">
		<!-- <div class="aboutus_selection">
			<div class="clearfix">
				<div :class="checked == 1?'selected':''" @click="change(1)">
					<span>公司简介</span>
				</div>
				<div :class="checked == 2?'selected':''" @click="change(2)">
					<span>总经理致辞</span>
				</div>
				<div :class="checked == 3?'selected':''" @click="change(3)">
					<span>荣誉资质</span>
				</div>
				<div :class="checked == 4?'selected':''" @click="change(4)">
					<span>成员企业</span>
				</div>
			</div>
		</div> -->
		<banner title="新闻资讯" :img="sty" />
		<div v-if="checked == 1" class="jianjie">
			<div class="newDetails">
				<div class="title">
					<h3>{{biaoti}}</h3>
					<h5>发布时间：{{time}}</h5>
				</div>
				<div class="content" v-html="detail">
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import Banner from "@/components/Banner";

	export default {
		name: "aboutus",
		components: {
			Banner,
		},
		data() {
			return {
				sty: {},
				checked: 1,
				selected: 0,
				list: [
				],
				title: "",
				tupian: "",
				biaoti:'',
				time:'',
				detail:''
			};
		},
		methods: {
			change(a) {
				var that = this;
				that.checked = a;
			},
			xuanze(a) {
				var that = this;
				that.selected = a;
				that.title = that.list[a].name;
				that.tupian = that.list[a].beijing;
			},
			getData(){
				var that = this;
				that.$axios({
					method: "post",
					url: "webpc/pcnewsmessige/getInfo",
					// data: this.$qs.stringify(data)
					params: {
						uuid:that.$route.query.uuid
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					var data = res.data.detail;
					console.log(data);
					that.biaoti = data.title;
					that.time = data.createtime.slice(0,10);
					that.detail = data.descp;
				})
			},
			//banner图
			getlunbo() {
				var that = this;
				that.$axios({
					method: "get",
					url: "system/pcmanage/list",
					// data: this.$qs.stringify(data)
					params: {
						location:2
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if(res.data.result == 200){
						var data = res.data.detail;
						that.sty = {
							backgroundImage: "url(" + data[0].showpath + ")",
						}
					}
					
				})
				
			},
		},
		mounted() {
			// this.checked =
			//   this.$route.query.checked == undefined ? 1 : this.$route.query.checked;
			var selected =
				this.$route.query.selected == undefined ? 0 : this.$route.query.selected;
			this.selected = selected;
			// this.title = this.list[selected].name;
			// this.tupian = this.list[selected].beijing;
			this.getData();
			this.getlunbo();
		},
		watch: {},
	};
</script>

<style lang="scss" scoped>
	.aboutus_banner {
		width: 100%;
		height: 423px;
		background-image: url(../assets/img/zhongyi/aboutus_banner.png);
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.aboutus_selection {
		width: 100%;

		.clearfix {
			width: 1200px;
			margin: auto;
			padding: 24px 0;

			div {
				float: left;
				box-sizing: border-box;
				width: 25%;
				text-align: center;
				height: 24px;
				line-height: 24px;
				cursor: pointer;
				border-right: 1px solid #d2d2d2;

				span {
					display: inline-block;
					height: 18px;
					line-height: 18px;
					padding-left: 30px;
					color: #363636;
					font-size: 16px;
					background-repeat: no-repeat;
					background-position: left top;
					background-size: contain;
				}
			}

			div:last-child {
				border-right: none;
			}

			div.selected span {
				color: #0385ca;
			}

			div:nth-of-type(1) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/01.png);
			}

			div:nth-of-type(1).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/01-selected.png);
			}

			div:nth-of-type(2) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/02.png);
			}

			div:nth-of-type(2).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/02-selected.png);
			}

			div:nth-of-type(3) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/03.png);
			}

			div:nth-of-type(3).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/03-selected.png);
			}

			div:nth-of-type(4) span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/04.png);
			}

			div:nth-of-type(4).selected span {
				background-image: url(../assets/img/zhongyi/aboutus-icon/04-selected.png);
			}
		}
	}

	.jianjie {
		background-color: #f2f1ef;
		width: 100%;
		// padding: 55px 0 75px;

		.clearfix {
			width: 1200px;
			margin: auto;
		}

		.left {
			float: left;
			width: 800px;

			p {
				font-size: 16px;
				color: #343434;
				line-height: 1.6em;
				margin-bottom: 14px;

				span {
					font-weight: 700;
				}
			}
		}

		.right {
			float: right;
			width: 365px;

			img {
				display: block;
				width: 365px;
				height: auto;
			}
		}
	}

	.qiye {
		height: 588px;
		background-image: url(../assets/img/zhongyi/zizhi_banner.png);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;

		.content {
			width: 1200px;
			margin: auto;
			box-sizing: border-box;
			height: 588px;
			padding-top: 97px;

			.title {
				text-align: center;
				margin-bottom: 82px;

				span {
					display: inline-block;
					height: 88px;
					line-height: 88px;
					padding-left: 89px;
					font-size: 30px;
					color: #fff;
					background-image: url(../assets/img/zhongyi/zizhi/jiangbei.png);
					background-size: contain;
					background-position: left top;
					background-repeat: no-repeat;
				}
			}

			.clearfix {
				div {
					float: left;
					width: 25%;
					text-align: center;

					img {
						display: block;
						width: 129px;
						height: auto;
						margin: 0 auto 32px;
					}

					p {
						color: #fff;
						font-size: 20px;
					}
				}
			}
		}
	}

	.zhengshu {
		background-color: #f2f1ef;

		.content {
			width: 1200px;
			padding-bottom: 40px;
			margin: auto;

			p {
				height: 90px;
				line-height: 90px;
				font-size: 30px;
				color: #272727;
				text-align: center;
			}

			div {
				img {
					float: left;
					width: 384px;
					height: auto;
					margin-bottom: 34px;
					margin-right: 24px;
				}

				img:nth-of-type(3n) {
					margin-right: 0px;
				}
			}
		}
	}

	.jingli {
		padding: 47px 0 84px;
		background-color: #f2f1ef;

		.content {
			width: 1200px;
			margin: auto;

			.clearfix {
				margin: 0 auto 40px;
			}

			p {
				color: #343434;
				font-size: 16px;
				line-height: 1.6em;
				margin-bottom: 12px;
			}

			.qianming {
				overflow: hidden;
				padding-top: 42px;

				img {
					float: right;
					width: 351px;
					height: auto;
				}
			}
		}
	}

	.chengyuan {
		background-color: #f2f1ef;
		padding: 30px 0 0;

		.clearfix {
			width: 1200px;
			margin: auto;

			.left {
				float: left;
				padding: 10px 0;
				background-color: #fff;

				>div {
					box-sizing: border-box;
					width: 260px;
					padding: 6px 9px;
					cursor: pointer;

					.content {
						width: 248px;
						box-sizing: border-box;
						height: 67px;

						display: table;
						overflow: hidden;

						.tupian {
							float: left;
							width: 91px;
							height: 67px;
							background-size: cover;
							background-position: center;
							background-repeat: no-repeat;
						}

						p {
							box-sizing: border-box;
							width: 157px;
							padding: 0 10px;
							display: table-cell;
							vertical-align: middle;
							font-size: 16px;
							color: #363636;
						}
					}
				}

				>div:hover,
				>div.selected {
					background-color: #0083c9;
				}

				>div:hover p,
				>div.selected p {
					color: #fff !important;
				}
			}

			.right {
				float: right;
				width: 930px;
				box-sizing: border-box;
				background-color: #fff;
				padding: 28px 44px 154px;

				.title {
					text-align: center;
					font-size: 20px;
					color: #0083c9;
					font-weight: bold;
					line-height: 1.6em;
					margin-bottom: 15px;
				}

				>p {
					color: #383838;
					font-size: 16px;
					line-height: 1.6em;
					text-indent: 16px;
					margin-bottom: 15px;
				}

				.lianxi {
					margin-bottom: 35px;

					p {
						color: #383838;
						font-size: 16px;
						line-height: 1.6em;
						text-indent: 16px;
					}
				}

				img {
					display: block;
					width: 496px;
					margin: auto;
				}
			}
		}
	}
	.newDetails{
		background-color: #fff;
		padding: 40px 30px 60px;
		box-sizing: border-box;
		width: 60%;
		margin: 0 auto;
		.title{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			border-bottom: 1px solid #BFBFBF;
			padding-bottom: 16px;
			h3{
				width: 360px;
				color: #1F1F1F;
				font-weight: 600;
				text-align: center;
			}
			h5{
				color: #6F6F6F;
				font-size: 14px;
				margin-top: 6px;
			}
		}
		.content{
			padding: 0 30px;
			box-sizing: border-box;
			margin-top: 18px;
			& ::v-deep p{
				font-size: 16px;
				line-height: 25px;
				color: #444;
				margin-top: 8px;
				text-indent: 2em;
				strong{
					font-weight: 700;
				}
				img{
					display: block;
					margin: 16px auto;
					max-width: 100%;
				}
			}
			& ::v-deep h4{
				font-size: 16px;
				line-height: 25px;
				color: #444;
				margin-top: 8px;
				text-indent: 2em;
				font-weight: 700;
			}
			
		}
		
	}
</style>
